import React from "react";
import { AttrTypeName } from "src/types/AttrType";
import {
  FormObjectSection,
  FormObjectSectionsStore,
} from "src/components/Forms/FormObjectSection";
import { observer } from "mobx-react-lite";
import { DrawTab } from "./DrawTab";
import {
  ZSchedSettingsPlanTemplate,
  ZSchedulingSettings,
} from "../../SchedulingTypes";
import { SchedulingObjType } from "../SchedulingSettingsStore";

interface PropsPlanTemplateFields {
  store: FormObjectSectionsStore<SchedulingObjType>;
}

const fieldName = (
  name: keyof ZSchedSettingsPlanTemplate,
): ["planTemplateSettings", keyof ZSchedSettingsPlanTemplate] => [
  "planTemplateSettings",
  name,
];

export const PlanTemplateFields: React.FC<PropsPlanTemplateFields> = observer(
  ({ store }) => (
    <DrawTab>
      <FormObjectSection<ZSchedulingSettings, SchedulingObjType>
        store={store}
        objKey={fieldName("templateObjectId")}
        objType="planTemplate"
        title="Объект: Шаблон плана"
        attrTitle="Выберите атрибуты:"
        attrs={[
          {
            attrKey: fieldName("nameAttributeId"),
            attrLabel: "Название",
            attrType: AttrTypeName.string,
          },
          {
            attrKey: fieldName("groupTaskListAttributeId"),
            attrLabel: "Список групп задач, включенных в план",
            attrType: AttrTypeName.childEntities,
          },
        ]}
      />
    </DrawTab>
  ),
);
